import { FC, ReactNode } from 'react';

import { CustomHandle } from '../custom-handle';
import { Label } from '../condition-label';

export interface IRenderBlock {
	label?: string | undefined;
	/**
	 * __simplici_accreditation_tile_choice__
	 * Rendered directly under the name row: the accreditation level chooser.
	 */
	control?: ReactNode;
	price: number;
	priceMax?: number;
	nodeId: string;
	stepId: string;
	stepKey: string;
}

/**
 * __simplici_accreditation_no_conditions__
 * The accreditation step takes no condition blocks.
 *
 * 506c used to render a condition builder here -- "Add new condition block", and
 * an If/Equals to/then row per block -- while 506b and "investor chooses"
 * rendered nothing. That made branching a property of one of the three levels
 * rather than of the step, which is not something the tile can explain: the same
 * step either could or could not branch depending on a radio above it.
 *
 * The builder and everything that fed it (block counting, the modify/clone
 * renumbering pass, the per-block question rows) are gone. `nodeId`, `stepId`
 * and `stepKey` stay on the interface -- callers still pass them -- but nothing
 * in here reads them any more.
 *
 * Blocks stored on a flow built before this are not rendered, and are dropped
 * from the node the moment its level is changed (accreditation-action's
 * clearConditionBlocks).
 */
export const RenderAccBlock: FC<IRenderBlock> = ({
	label,
	control,
	price,
	priceMax,
}) => {
	return (
		<>
			<CustomHandle />
			<Label
				label={label || ''}
				price={price}
				max={priceMax}
				priceLabel="Verification"
			/>
			{control}
		</>
	);
};
